import {
	PROVIDER_MODE_LABELS,
	PROVIDER_MODE_MESSAGES,
	type ProviderMode,
	type ProviderModeStatusDto,
} from "@/types/ai-assistant-provider-mode";

/** Opsi pilihan mode untuk kartu "Mode penyedia". */
export const PROVIDER_MODE_OPTIONS: {
	value: ProviderMode;
	label: string;
	description: string;
}[] = [
	{
		value: "claude_chatgpt",
		label: PROVIDER_MODE_LABELS.claude_chatgpt,
		description:
			"Utama: Claude (kartu Chat). Cadangan: ChatGPT (dipakai otomatis bila pindah otomatis dinyalakan).",
	},
	{
		value: "chatgpt_only",
		label: PROVIDER_MODE_LABELS.chatgpt_only,
		description:
			"Utama: ChatGPT (kartu Chat cadangan). Claude tetap tersimpan sebagai Cadangan.",
	},
];

/** Alasan mode belum bisa disimpan (null = boleh). Sama dengan pesan penolakan server. */
export function modeBlockedReason(
	status: ProviderModeStatusDto,
	mode: ProviderMode,
	cryptoConfigured: boolean,
): string | null {
	if (!cryptoConfigured) return PROVIDER_MODE_MESSAGES.cryptoMissing;
	if (status.available[mode]) return null;
	return mode === "chatgpt_only"
		? PROVIDER_MODE_MESSAGES.needOpenAi
		: PROVIDER_MODE_MESSAGES.needClaude;
}

/** Teks peringatan tarif per model OpenAI yang belum punya tarif token lengkap. */
export function rateWarningLines(status: ProviderModeStatusDto): string[] {
	const models = [...new Set(status.missingRates.map((w) => w.model))];
	return models.map(
		(model) =>
			`Model ${model} belum punya tarif — isi di kartu Tarif model supaya estimasi biaya akurat.`,
	);
}
